module.exports = __webpack_public_path__ + "static/media/entregapapasalcaldesa.c9846d19.mp3";